import React from 'react'
import classNames from 'classnames'
import Card from 'src/components/card'
import Picture from 'src/components/picture'
import Button from 'src/components/button'
import { useStore } from 'src/state'

const TrainerCard = ({
  id,
  name,
  profilePicture,
  location,
  specialties,
  quote,
}) => {
  const {
    trainerSettings: {
      locationTitleText,
      specialtiesTitleText,
      quoteTitleText,
    },
    showTrainerCardOverlay,
    trainerCardId,
    hideTrainerCardOverlay,
    shouldShowTrainerCardOverlay,
    windowWidth,
    isBrowser,
  } = useStore()
  const displayAsMobile = windowWidth < 768 && isBrowser
  const isOverlayVisible = shouldShowTrainerCardOverlay && trainerCardId === id

  const overlay = (
    <Button
      onMouseLeave={() => !displayAsMobile && hideTrainerCardOverlay}
      className={classNames(
        'trainer-card-inner-overlay',
        displayAsMobile && 'display-as-mobile',
        isOverlayVisible && 'overlay-visible'
      )}
    >
      <Picture
        className="profile-picture"
        defaultWidth={750}
        image={profilePicture}
        fitWidth
        cover
      />
      <div className="background-color" />
      <div className="details">
        {location && (
          <>
            <div className="label">{locationTitleText}</div>
            <p className="detail location">{location}</p>
          </>
        )}
        {specialties && (
          <>
            <div className="label">{specialtiesTitleText}</div>
            <p className="detail specialties">{specialties}</p>
          </>
        )}
        {quote && (
          <>
            <div className="label">{quoteTitleText}</div>
            <p className="detail quote">"{quote}"</p>
          </>
        )}
      </div>
      <p className="name card-title">{name}</p>
    </Button>
  )

  return (
    <Card
      className={classNames(
        'trainer-card',
        isOverlayVisible && 'overlay-visible'
      )}
    >
      <Button
        className="card-content"
        onClick={() => displayAsMobile && showTrainerCardOverlay(id)}
        onMouseEnter={() => !displayAsMobile && showTrainerCardOverlay(id)}
      >
        <Picture
          className="profile-picture"
          defaultWidth={750}
          image={profilePicture}
          fitWidth
          cover
        />
        <p className="name card-title">{name}</p>
      </Button>
      {displayAsMobile ? null : overlay}
    </Card>
  )
}

export default TrainerCard
